import {
	IconCheckCircle,
	IconError,
	IconInfo,
	IconWarning
} from '@tvg/fuse-icons'
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

const variantConfig = {
	warning: {
		background: 'var(--color-universal-bronzeLight)',
		iconColour: 'var(--color-universal-bronzeMid)',
		icon: renderToStaticMarkup(<IconWarning />),
	},
	error: {
		background: 'var(--color-universal-redLight)',
		iconColour: 'var(--color-universal-redMid)',
		icon: renderToStaticMarkup(<IconError />),
	},
	success: {
		background: 'var(--color-universal-greenLight)',
		iconColour: 'var(--color-universal-greenMid)',
		icon: renderToStaticMarkup(<IconCheckCircle />),
	},
	information: {
		background: 'var(--color-universal-blueLight)',
		iconColour: 'var(--color-universal-blueMid)',
		icon: renderToStaticMarkup(<IconInfo />),
	},
};

export default variantConfig;
